import React, { useState, useEffect } from 'react';
import "./Header.css";
import SearchIcon from "@material-ui/icons/Search";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  NavIcon,
  MobileIcon,
  NavMenu,
  NavItem,
  NavItemBtn,
  NavLinks,
  NavBtnLink
} from './Navbar.elements';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Button } from './globalStyles';
import { Avatar, IconButton } from '@material-ui/core';

function Header() {
  const [{ basket, user }, dispatch] = useStateValue();
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);


  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);
 


  const handleAuthenticaton = () => {
    if (user) {
      auth.signOut();
    }
  }



    return (
      
      <>
        

        <IconContext.Provider value={{ color: '#fff' }}>
          <Nav >
            <NavbarContainer className="header">
              <NavLogo to='/' onClick={closeMobileMenu}>
               <img className="logoimg" src="https://imgur.com/L0n3MhL.png" />
               
      

               
              </NavLogo>
              <MobileIcon onClick={handleClick}>
                {click ? <FaTimes /> : <FaBars />}
              </MobileIcon>
              <NavMenu onClick={handleClick} click={click}>
                <NavItem>
                  <NavLinks to='/webdesign' onClick={closeMobileMenu}>
                    Appliance Repair
                  </NavLinks>
                </NavItem>
                <NavItem>
                  <NavLinks to='/appdesign' onClick={closeMobileMenu}>
                     Maintenance
                  </NavLinks>
                </NavItem>
                <NavItem>
                  <NavLinks to='/services' onClick={closeMobileMenu}>
                  Replacement
                  </NavLinks>
                </NavItem>
                <NavItem>
                  <NavLinks to='/seo' onClick={closeMobileMenu}>
                  Virtual
                  </NavLinks>
                </NavItem>
               
    

                <NavItemBtn>
                  {button ? (
                    <NavBtnLink to={!user && '/login'}>
                      <Button onClick={handleAuthenticaton} primary > {'Member' } {user ? 'Sign Out' : 'Sign In'} </Button>
                      
                      <Link to="/login">
          <div className="header__optionBasket">
          <Avatar className="avatar" src={user?.photoURL} />
            <span className="header__optionLineTwo header__basketCount">
              {basket?.length}
            </span>
          
          </div>
          
        </Link>
                    </NavBtnLink>
                   
                  ) : (
                    <NavBtnLink to={!user && '/login'}>
                      
                      <Button onClick={closeMobileMenu} onClick={handleAuthenticaton} fontBig primary>
                      { 'Member'} {user ? 'Sign Out' : 'Sign In'}

                      </Button>
                      <Link to="/login">
          <div className="header__optionBasket">
          <Avatar className="avatar" src={user?.photoURL} />
            <span className="header__optionLineTwo header__basketCount">
              {basket?.length}
              
            </span>
            
          </div>
        </Link>
                    </NavBtnLink>
                  )}
                </NavItemBtn>
              </NavMenu>
            </NavbarContainer>
          </Nav>
        </IconContext.Provider>
      </>
    );
  }

export default Header;
